import React, {FunctionComponent} from "react";
import {Box, Grid} from "@mui/material";
import ManagerUserTokenGeneral from "@/Domains/AuthenticationManagement/Usertoken/Forms/ManagerUserTokenGeneral";
import {
    UserTokenMainQueryRendererQueryResponse
} from "@/Domains/UserManagement/User/QueryRenderer/__generated__/UserTokenMainQueryRendererQuery.graphql";

interface IUserTokenForm {
    viewData: UserTokenMainQueryRendererQueryResponse;
    token: string;
    onSubmit: any;
}

const UserTokenForm: FunctionComponent<IUserTokenForm> = ({
                                                    viewData,
    onSubmit,
    token
                                                }): JSX.Element => {
    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={24}>
                    <Grid item xs={12}>
                        <ManagerUserTokenGeneral
                                                   onSubmit={onSubmit}
                                                   viewData={viewData}
                                                   token={token}/>
                    </Grid>

                </Grid>
            </Grid>
        </>
    );
};

export default UserTokenForm;
